<template>
  <div class="productCategory">
    <div class="container">
      <div>
        <Title />
        <div class="row justify-content-between">
          <Breadcrumb />
          <div class="col-12 col-sm text-end mb-3 mb-sm-0">
            <button
              type="button"
              class="btn btn-transparent"
              @click="showModal(null)"
            >
              新增分類
            </button>
          </div>
        </div>
      </div>
      <div class="card mb-3 table-top-bar">
        <div class="card-body p-0">
          <div class="input-group">
            <span class="input-group-text d-none d-sm-block">
              顯示第
              {{ currentPage == 1 ? 1 : perPage * (currentPage - 1) + 1 }} 至
              {{
                currentPage == 1
                  ? totalRows > perPage
                    ? perPage
                    : totalRows
                  : perPage * (currentPage - 1) + perPage > totalRows
                  ? totalRows
                  : perPage * (currentPage - 1) + perPage
              }}
              項結果，共 {{ totalRows }} 項
            </span>
            <input
              v-model="filter"
              type="text"
              class="form-control"
              placeholder="搜尋"
            />
            <span class="input-group-text"><i class="bi bi-search"></i></span>
          </div>
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-body">
          <b-table
            :responsive="windowWidth > breakpoints.sm"
            :stacked="windowWidth <= breakpoints.sm"
            borderless
            no-provider-filtering
            head-variant="light"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template v-slot:head()="scope">
              <div class="text-nowrap">
                {{ scope.label }}
              </div>
            </template>
            <template v-slot:cell(img_url)="data">
              <div class="d-flex">
                <div class="imgBox" style="width: 100px">
                  <div class="imgBox-inner">
                    <div class="imgBox-fit">
                      <img
                        v-if="data.item.img_url.small_img"
                        :src="data.item.img_url.small_img"
                        alt=""
                      />
                      <i v-else class="bi bi-image"></i>
                    </div>
                  </div>
                </div>
                <div class="imgBox ms-2" style="width: 100px">
                  <div class="imgBox-inner">
                    <div class="imgBox-fit">
                      <img
                        v-if="data.item.img_url.big_img"
                        :src="data.item.img_url.big_img"
                        alt=""
                      />
                      <i v-else class="bi bi-image"></i>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-slot:cell(active)="data">
              <div class="d-flex flex-nowrap flex align-items-center">
                <button
                  @click="showModal(data.item.id)"
                  type="button"
                  class="btn btn-link px-1"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="編輯"
                >
                  <i class="bi bi-pencil mx-1 fs-5"></i>
                </button>
                <router-link
                  custom
                  v-slot="{ navigate }"
                  :to="{
                    name: 'ProductCategorySub',
                    params: { id: data.item.id }
                  }"
                >
                  <button
                    @click="navigate"
                    type="button"
                    class="btn btn-link px-1"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="子分類"
                  >
                    <i class="bi bi-folder"></i>
                  </button>
                </router-link>
                <button
                  v-if="data.item.product_count"
                  @click="showTOP12Modal(data.item.id)"
                  type="button"
                  class="btn btn-link px-1"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="TOP12"
                >
                  <i class="bi bi-sort-up"></i>
                </button>
                <button
                  v-if="
                    !data.item.sub_category_count && !data.item.product_count
                  "
                  @click="showDeleteModal(data.item.id, data.item.name)"
                  type="button"
                  class="btn btn-link px-1 text-danger"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="刪除"
                >
                  <i class="bi bi-trash me-2"></i>
                </button>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="d-block d-sm-none text-center mb-3">
        顯示第 {{ currentPage == 1 ? 1 : perPage * (currentPage - 1) + 1 }} 至
        {{
          currentPage == 1
            ? totalRows > perPage
              ? perPage
              : totalRows
            : perPage * (currentPage - 1) + perPage > totalRows
            ? totalRows
            : perPage * (currentPage - 1) + perPage
        }}
        項結果，共 {{ totalRows }} 項
      </div>
      <b-pagination
        v-if="totalRows > perPage"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="right"
        first-number
        last-number
        class="mb-sm-0 mb-3 mt-sm-0 mt-3"
      ></b-pagination>
    </div>
    <div
      class="modal fade"
      id="productCategoryModal"
      tabindex="-1"
      ref="productCategoryModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content" v-if="modalDate">
          <div class="modal-header">
            <h5 class="modal-title">{{ isEdit ? '編輯分類' : '新增分類' }}</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="save">
              <div class="mb-3">
                <label for="modalTitle" class="form-label required"
                  >分類名稱</label
                >
                <input
                  v-model="modalDate.name"
                  type="text"
                  class="form-control"
                  id="modalTitle"
                  placeholder="請輸入"
                  required
                />
              </div>
              <div class="mb-3">
                <label for="modalStaticUri" class="form-label">自定網址</label>
                <input
                  v-model="modalDate.static_uri"
                  type="text"
                  class="form-control"
                  id="modalStaticUri"
                  placeholder="請輸入"
                  pattern="[0-9a-z\-_]+"
                />
                <div class="form-text">
                  只能用英文小寫、數字及'-'、'_'符號(非字首)，不可有空白 <br />
                  用於強化 SEO 搜尋
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="imageSmallFile" class="form-label required"
                      >首頁分類圖<br />(圖片格式：JPG、PNG)</label
                    >
                    <div class="imgBox-has-close">
                      <button
                        v-if="modalDate.img_url.small_img"
                        @click="removeImage('small_img')"
                        type="button"
                        class="btn-close"
                        aria-label="Close"
                      />
                      <label
                        for="imageSmallFile"
                        class="imgBox w-100"
                        style="cursor: pointer"
                      >
                        <div class="imgBox-inner">
                          <div class="imgBox-fit">
                            <img
                              v-if="modalDate.img_url.small_img"
                              :src="modalDate.img_url.small_img"
                              alt=""
                            />
                            <i v-else class="bi bi-image"></i>
                          </div>
                        </div>
                      </label>
                    </div>
                    <input
                      class="form-control d-none"
                      type="file"
                      id="imageSmallFile"
                      accept="image/png, image/jpeg"
                      @change="onFileChange($event.target, 'small_img')"
                      :class="{ 'is-invalid': invalid.small_img }"
                    />
                    <div class="invalid-feedback" v-show="invalid.small_img">
                      {{ invalid.small_img }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="imageSmallFile" class="form-label"
                      >分類內頁大圖<br />(圖片格式：JPG、PNG)</label
                    >
                    <div class="imgBox-has-close">
                      <button
                        v-if="modalDate.img_url.big_img"
                        @click="removeImage('big_img')"
                        type="button"
                        class="btn-close"
                        aria-label="Close"
                      />
                      <label
                        for="imageBigFile"
                        class="imgBox w-100"
                        style="cursor: pointer"
                      >
                        <div class="imgBox-inner">
                          <div class="imgBox-fit">
                            <img
                              v-if="modalDate.img_url.big_img"
                              :src="modalDate.img_url.big_img"
                              alt=""
                            />
                            <i v-else class="bi bi-image"></i>
                          </div>
                        </div>
                      </label>
                    </div>
                    <input
                      class="form-control d-none"
                      type="file"
                      id="imageBigFile"
                      accept="image/png, image/jpeg"
                      @change="onFileChange($event.target, 'big_img')"
                    />
                  </div>
                </div>
              </div>
              <button ref="submit" type="submit" class="d-none"></button>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              取消
            </button>
            <button
              @click="$refs.submit.click()"
              type="button"
              class="btn btn-primary"
            >
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="productTop12Modal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      ref="productTop12Modal"
    >
      <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content" v-if="modalTop12Date">
          <div class="modal-header justify-content-center">
            <h5 class="modal-title">{{ modalTop12Date.name }} TOP12</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body text-center">
            <div class="table-responsive">
              <table class="table align-middle text-nowrap border">
                <thead>
                  <tr>
                    <th scope="col" class="text-center" style="width: 54px">
                      排序
                    </th>
                    <th scope="col">產品</th>
                    <th scope="col" style="width: 54px">移除</th>
                  </tr>
                </thead>
                <draggable
                  tag="tbody"
                  v-model="modalTop12Date.top"
                  handle=".drag"
                  animation="1000"
                >
                  <tr
                    v-for="(top12Date, index) in modalTop12Date.top"
                    :key="'product_category' + index"
                  >
                    <td class="drag text-center" style="cursor: all-scroll">
                      <i class="bi bi-arrows-move"></i>
                    </td>
                    <td>
                      <select
                        v-model="modalTop12Date.top[index].id"
                        class="form-select"
                        aria-label="Default select example"
                        v-if="categoryProduct"
                      >
                        <option value="">請選擇</option>
                        <option
                          v-for="product in categoryProduct.product"
                          :value="product.id"
                          :key="'product' + product.id"
                        >
                          {{ product.name }}
                        </option>
                      </select>
                    </td>
                    <td>
                      <button
                        class="btn btn-close p-2"
                        @click="deleteTop12(index)"
                      ></button>
                    </td>
                  </tr>
                </draggable>
              </table>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              @click="addCategoryTop12"
              type="button"
              class="btn btn-outline-primary"
              v-if="
                modalTop12Date &&
                (!modalTop12Date.top || modalTop12Date.top.length < 12)
              "
            >
              新增
            </button>
            <button
              type="button"
              class="btn btn-outline-gray ms-auto"
              data-bs-dismiss="modal"
            >
              取消
            </button>
            <button @click="saveTop12" type="button" class="btn btn-primary">
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>
    <DeleteModal
      name="分類"
      :deleteItem="deleteItem"
      @confirmDelete="deleteEvent"
    />
  </div>
</template>

<script>
import { product } from '@/http/api/product.js'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import { Modal } from 'bootstrap'
import draggable from 'vuedraggable'
import Title from '@/components/layout/Title.vue'
import Breadcrumb from '@/components/layout/Breadcrumb.vue'
import DeleteModal from '@/components/modal/DeleteModal.vue'

const defaultModalDate = {
  name: null,
  static_uri: null,
  img_url: {
    small_img: null,
    big_img: null
  }
}

export default {
  name: 'ProductCategory',
  components: {
    Title,
    draggable,
    Breadcrumb,
    DeleteModal
  },
  data () {
    return {
      bootstrap_modal: null,
      categoryProduct: null,
      currentPage: 1,
      deleteItem: '',
      errMsg: null,
      errMsgKey: {
        name: '分類名稱',
        static_uri: '自訂網址',
        img_url: {
          small_img: '首頁分類圖',
          big_img: '內頁分類圖大圖'
        },
        sort_list: 'Top12'
      },
      filter: null,
      filterOn: ['name', 'product_count', 'sub_category_count', 'static_uri'],
      fields: [
        {
          key: 'name',
          label: '分類名稱',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'img_url',
          label: '首頁分類圖 / 分類內頁大圖',
          class: 'align-middle'
        },
        {
          key: 'sub_category_count',
          label: '子分類數量',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'product_count',
          label: '產品數量',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'static_uri',
          label: '自定網址',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'active',
          label: '功能',
          class: 'align-middle'
        }
      ],
      isEdit: false,
      invalid: {
        small_img: null
      },
      items: null,
      modalID: null,
      modalDate: JSON.parse(JSON.stringify(defaultModalDate)),
      modalTop12Date: null
    }
  },
  computed: {
    ...mapState([
      'token',
      'windowWidth',
      'breakpoints',
      'perPage',
      'totalRows'
    ]),
    ...mapGetters(['errMsgInfo'])
  },
  watch: {
    'token.headers.Authorization': function (data) {
      if (data) {
        this.getData()
      }
    },
    currentPage () {
      this.$nextTick(() => this.InitBootstrapTooltip())
    },
    items () {
      this.$nextTick(() => this.InitBootstrapTooltip())
    },
    modalTop12Date: {
      handler () {
        this.getProduct()
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations([
      'AlertsInfo',
      'Alerted',
      'InitBootstrapTooltip',
      'Loading',
      'Loaded',
      'SetRouterName',
      'SetTotalRows',
      'SetErrMsg',
      'SetErrMsgKey',
      'ToggleDeleteModal'
    ]),
    ...mapActions(['uploadImage']),
    addCategoryTop12 () {
      const vm = this
      vm.modalTop12Date.top.push('')
    },
    createCategory () {
      const vm = this
      product
        .createCategory(vm.modalDate, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '創建資料成功'
            })
            vm.bootstrap_modal.hide()
            vm.getData()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,

              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    deleteEvent () {
      const vm = this
      product
        .deleteCategory(vm.modalID, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '刪除資料成功'
            })
            vm.getData()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.ToggleDeleteModal(false)
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.ToggleDeleteModal(false)
          vm.Alerted()
          vm.Loaded()
        })
    },
    deleteTop12 (index) {
      const vm = this
      vm.modalTop12Date.top.splice(index, 1)
    },
    getData () {
      const vm = this
      const config = { ...vm.token }
      config.params = {
        parent_id: 0
      }
      product
        .getCategory('', config)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.items = data.data.sort((a, b) =>
              Date.parse(a.created_at).valueOf() >
              Date.parse(b.created_at).valueOf()
                ? -1
                : 1
            )
            vm.SetTotalRows(vm.items.length)
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
        })
    },
    getCategoryTop12 (id) {
      const vm = this
      product
        .getCategoryTop(id, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.modalTop12Date = res.data.data
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
        })
    },
    getProduct () {
      const vm = this
      product
        .getCategory(vm.modalID, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.categoryProduct = data.data
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
        })
    },
    onFiltered (filteredItems) {
      const vm = this
      vm.SetTotalRows(filteredItems.length)
      vm.currentPage = 1
    },
    onFileChange (event, type) {
      const vm = this
      vm.uploadImage(event).then((value) => {
        if (value) {
          vm.modalDate.img_url[type] = value
        }
      })
    },
    removeImage (type) {
      const vm = this
      switch (type) {
        case 'small_img':
          vm.modalDate.img_url.small_img = null
          break
        case 'big_img':
          vm.modalDate.img_url.big_img = null
          break
        default:
          break
      }
    },
    showModal (id) {
      const vm = this
      vm.invalid.small_img = null
      vm.bootstrap_modal = new Modal(vm.$refs.productCategoryModal, {
        backdrop: 'static',
        keyboard: false
      })
      vm.modalID = id
      vm.isEdit = false
      if (!id) {
        vm.modalDate = JSON.parse(JSON.stringify(defaultModalDate))
        vm.bootstrap_modal.show()
        return
      }
      vm.isEdit = true
      vm.Loading()
      product
        .getCategory(id, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.modalDate = data.data
            vm.bootstrap_modal.show()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    showTOP12Modal (id) {
      const vm = this
      vm.modalID = id
      vm.getCategoryTop12(id)
      vm.bootstrap_modal = new Modal(vm.$refs.productTop12Modal, {
        backdrop: 'static',
        keyboard: false
      })
      vm.bootstrap_modal.show()
    },
    showDeleteModal (id, title) {
      const vm = this
      vm.modalID = id
      vm.deleteItem = title
      vm.ToggleDeleteModal(true)
    },
    save () {
      const vm = this
      if (!vm.modalDate.img_url.small_img) {
        vm.invalid.small_img = '分類小圖為必填'
        return
      }
      if (vm.invalid.small_img) {
        setTimeout(() => {
          vm.invalid.small_img = null
        }, 2000)
        return
      }
      vm.Loading()
      vm.modalDate.small_img = vm.modalDate.img_url.small_img
      vm.modalDate.big_img = vm.modalDate.img_url.big_img
      if (vm.isEdit) {
        vm.updateCategory()
        return
      }
      vm.createCategory()
    },
    saveTop12 () {
      const vm = this
      const sortList = []
      vm.modalTop12Date.top.forEach((top12) => {
        sortList.push(top12.id)
      })
      vm.Loading()
      product
        .updateCategoryTop(vm.modalDate, { sort_list: sortList }, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '更新資料成功'
            })
            vm.bootstrap_modal.hide()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    updateCategory () {
      const vm = this
      product
        .updateCategory(vm.modalID, vm.modalDate, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '更新資料成功'
            })
            vm.bootstrap_modal.hide()
            vm.getData()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    }
  },
  created () {
    const vm = this
    vm.SetRouterName(vm.$route.name)
    vm.SetErrMsgKey(vm.errMsgKey)
  },
  mounted () {
    const vm = this
    if (vm.token.headers.Authorization) {
      vm.getData()
    }
  }
}
</script>
